import z from "zod";

import { createCall, spellbook } from "@sdk/spellbook";

import { withAccountOrNetworkAuthHeaders } from "./apiHelpers";

const endpoint = spellbook("/me/organisations/documents").GET();

export type GetOrganisationDocumentsQuery = z.infer<typeof endpoint.q>;
export type GetOrganisationDocumentsResponse = z.infer<typeof endpoint.res>;
export type OrganisationDocument = NonNullable<
    GetOrganisationDocumentsResponse["documents"]
>[number];

export async function getOrganisationDocuments({
    query,
    signal,
}: {
    query: GetOrganisationDocumentsQuery;
    signal?: AbortSignal;
}): Promise<GetOrganisationDocumentsResponse> {
    const call = createCall(endpoint, (r) => fetch(withAccountOrNetworkAuthHeaders(r)));
    const res = await call({ query, signal });

    return res;
}
